import React, { useState } from 'react';
import { Container, Typography, Grid, Paper, Box } from '@mui/material';
import { ObjectHierarchicalPicker } from '../components/ObjectHierarchicalPicker';
import { ObjectMetadataValue, HIERARCHY_ROOT_IDS } from '../types/ObjectHierarchicalMetadataValue';

export const TestObjectPicker = () => {
  const [workType, setWorkType] = useState<ObjectMetadataValue>({ textValue: '', isFreetext: true });
  const [materials, setMaterials] = useState<ObjectMetadataValue[]>([]);

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>
        ObjectHierarchicalPicker Test
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Getty Work Type (Single Selection)</Typography>
            <ObjectHierarchicalPicker
              hierarchyRootId={HIERARCHY_ROOT_IDS.workTypes}
              label="Getty Work Type"
              value={workType}
              onChange={(value) => setWorkType(value as ObjectMetadataValue)}
              multiple={false}
            />
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Current value: {JSON.stringify(workType, null, 2)}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Getty Materials (Multiple Selection)</Typography>
            <ObjectHierarchicalPicker
              hierarchyRootId={HIERARCHY_ROOT_IDS.materials}
              label="Getty Materials"
              value={materials}
              onChange={(value) => setMaterials(value as ObjectMetadataValue[])}
              multiple={true}
            />
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Current values: {JSON.stringify(materials, null, 2)}
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};
